import { render, staticRenderFns } from "./OrderRecord.vue?vue&type=template&id=ee13fbc0&scoped=true"
import script from "./OrderRecord.vue?vue&type=script&lang=js"
export * from "./OrderRecord.vue?vue&type=script&lang=js"
import style0 from "./OrderRecord.vue?vue&type=style&index=0&id=ee13fbc0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee13fbc0",
  null
  
)

export default component.exports